export const moveElementPosition = (arr, from, to) => {
  if (to >= 0) {
    // Se trabaja sobre una copia: mutar el array recibido corrompe el estado
    // de Redux, que debe tratarse como inmutable.
    const result = [...arr];
    const cutOut = result.splice(from, 1)[0]; // cut the element at index 'from'
    result.splice(to, 0, cutOut); // insert it at index 'to'
    return result;
  }

  return arr;
};
